import { beAccountSettimgsGetSmsCreditsByList } from 'Api/beAccountSettingsApi'
import {
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters
} from 'Api/beFiltersApi'
import { beRcsGetMessage } from 'Api/beRcs'
import {
  beRcsSendEnqueue,
  beRcsSendGetQueuing,
  beRcsSendPatchSchedule
} from 'Api/beRcsSend'
import {
  beRecipientGetSmsListSubscriptionCounters,
  beRecipientLazySearch
} from 'Api/beRecipientApi'
import { LOGIN_TYPE_ADM, LOGIN_TYPE_ADMLIMITED } from 'Constants/index'
import getIntl from 'Helpers/intl'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE,
  storeGet
} from 'mailup-react-helpers'

export async function getSmsCredits() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const ret = await beAccountSettimgsGetSmsCreditsByList(idList)
  return ret
}

export async function getQueuings(idQueuing) {
  const result = await beRcsSendGetQueuing(idQueuing)
  return result
}

export async function createSendingQueue(idMessage, data) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRcsSendEnqueue(idList, idMessage, data)
  return result
}

export async function getSmsListSubscriptionCounters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRecipientGetSmsListSubscriptionCounters(idList)

  return result
}

export async function lazySearchForRecipients(params, searchConditions) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRecipientLazySearch(idList, params, searchConditions)
  return result
}

export async function getMessage(idMessage) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRcsGetMessage(idList, idMessage)
  return result
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const allFilters = (
    await beFiltersGetListOfFilters(idList, {
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false,
      hidden
    })
  ).Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export async function patchSchedule(idSchedule, params) {
  const result = beRcsSendPatchSchedule(idSchedule, params)

  return result
}
